import React from 'react';
import { IoSearch } from 'react-icons/io5';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

export const SearchInput = ({
  setSearch,
  search = '',
  placeholder = '',
  showButton = false,
  searchChatsZoneStyle = {},
  searchChatsInputStyle = {}
}) => {
  const { primary_color } = useSelector((state) => state.systemConfiguration);

  return (
    <SearchChatsZone style={searchChatsZoneStyle}>
      <SearchInputWrapper>
        <SearchChatsInput
          type="text"
          placeholder={placeholder}
          withData={search}
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
          }}
          aria-label={placeholder || 'Pesquisar'}
          style={{ ...searchChatsInputStyle }}
        />
        {showButton && (
          <SearchButton type="button" bgColor={primary_color}>
            <IoSearch size={18} color="#fff" />
          </SearchButton>
        )}
      </SearchInputWrapper>
    </SearchChatsZone>
  );
};

const SearchInputWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
`;

const SearchChatsInput = styled.input`
  padding: 1rem 3rem 1rem 1rem;
  border-radius: 10px;
  font-size: 0.9rem;
  width: 100%;
  height: 40px;
  outline: none;
  transition: box-shadow 0.3s ease, background 0.3s ease, border 0.3s ease;
  font-weight: 600;
  font-size: 15px;

  border: 0.12rem solid ${(props) => (props.withData ? '#1890ff' : 'lightgray')};
  background: ${(props) => (props.withData ? '#e6f7ff' : '#fff')};
  color: ${(props) => (props.withData ? '#222' : '#33333380')};
  box-shadow: ${(props) => (props.withData ? '0 0 0 2px #1890ff33' : 'none')};
  &::placeholder {
    color: #33333390;
    font-weight: 400;
  }
`;

export const SearchChatsZone = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  position: relative;
  width: 100%;
`;

export const SearchButton = styled.button`
  background-color: ${(props) => props.bgColor || 'gray'};
  opacity: 0.8;
  border-radius: 0.5rem;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  width: 32px;
  position: absolute;
  right: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  transition: opacity 0.3s ease;
  border: none;

  &:hover {
    opacity: 1;
  }
`;
